export const en = {
    "k_c78ca785": "Failed to open editor: Missing application ID or page ID parameter",
    "k_12477066": "Failed to open editor: page does not exist",
    "k_304ff7f9": "Create offline tasks",
    "k_9c36aae0": "Delete offline tasks",
    "k_10143f5f": "Create offline configurations",
    "k_b1bb5121": "Update offline configuration",
    "k_1a099cc4": "Delete offline configuration",
    "k_8c27b8e5": "Debugging offline configuration",
    "k_c59d0a44": "Infinite AI function call failed",
    "k_a469ff8b": "Intelligent parsing of API documents",
    "k_77b23ee0": "Resolution failure",
    "k_66aa4311": "The analysis is complete, please confirm what you want to use",
    "k_dec1050b": "Determine to modify",
    "k_c2bb8e90": "Paste the API document below to automatically fill in the interface configuration",
    "k_a3deab25": "Inaccurate results? You can adjust the input and parse it again.",
    "k_dd2893f7": "Parsing",
    "k_8bae92e4": "Please paste in the HTTP API description document (including address, parameter description, etc.) without format requirements",
    "k_c8e4d1ab": "Please post it into the API document",
    "k_8ec21141": "Please convert the API description document into the specified output format. Note that the XML tags in the format need to keep the same order and tag names.",
    "k_56151220": "Domain name",
    "k_472a54df": "Path",
    "k_f7bd0b1b": "Response type",
    "k_832503ea": "Query parameter",
    "k_8fb5c154": "Body parameter",
    "k_d9b3ed01": "//Set request header",
    "k_7fc68bb9": "Path parameters",
    "k_d75c2d09": "//Interpolate and replace parameter {arg_0} in URL",
    "k_1285f8a3": "Nothing was parsed. The following is the original response:\n\n{arg_0}",
    "k_b0a31aa6": "The analysis has been completed. Please confirm the result",
    "k_ff9d6f89": "API document parsing error",
    "k_3d5bd4c5": "Applied, pay attention to check debugging parameters",
    "k_6141cc5f": "This function is not open yet. Please contact the administrator to open it"
};
